export default "__VITE_ASSET__1EmF4JKV__"